import I18n from 'I18n';
import { createAsyncAction } from 'conversations-async-data/async-action/createAsyncAction';
import { MARK_AS_SPAM } from '../constants/asyncActionTypes';
import { setFilterStatus } from '../clients/setFilterStatus';
export const markAsSpam = createAsyncAction({
  requestFn: setFilterStatus,
  actionTypes: MARK_AS_SPAM,
  toRecordFn: () => null,
  successMetaActionCreator: () => ({
    notification: {
      type: 'success',
      titleText: I18n.text('conversations-thread-view.alerts.titles.success'),
      message: I18n.text('conversations-thread-view.alerts.mark-thread-spam.message')
    }
  })
});